const logicalOrOperator = {
  match: '+',
}

export default logicalOrOperator
